<template>

  <v-card>
    <v-card-text>
      <v-container grid-list-lg fluid class="photo-animal-container">
        <v-layout dense row wrap v-if="animal">
          <v-flex xs12 md6>
            <v-img 
              v-bind:src="animal.image"
              ></v-img>
          </v-flex>
          <v-flex xs12 md6>
            <image-grid-info
              :animal="animal"
              :auxs="auxs"
            ></image-grid-info>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>

</template>
<script>
import ImageGridInfo from './ImageGridInfo'
export default {
  name: 'app-romaneio-card-image',
  components: {
    'image-grid-info' : ImageGridInfo,
  },
  props : ['animal', 'auxs'],
  data: () => ({
    
  }),
  mounted () {
    
  },
  methods : {
    
  }
}
</script>

<style scoped lang="css">
.photo-animal-container {
  padding: 0px;
}
</style>
